import { render, staticRenderFns } from "./SubsectionDownloadModal.vue?vue&type=template&id=d410d4ce&"
import script from "./SubsectionDownloadModal.vue?vue&type=script&setup=true&lang=js&"
export * from "./SubsectionDownloadModal.vue?vue&type=script&setup=true&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports